import { BASE_SCOUT_HEADERS, BIO_CATEGORY } from './ScoutPlayers.constants';
import {
  getBiometricHeaders,
  getStatHeaders,
} from './ScoutPlayers.dataManipulation';

export default function useScoutTableHeaders({
  statDefinitions,
  columnStatKeys,
  filterStatKeys,
  bioStatKeys,
  selectedCategoryName,
}) {
  const filterStatHeaders = getStatHeaders(filterStatKeys, statDefinitions);
  const columnStatHeaders = getStatHeaders(columnStatKeys, statDefinitions);
  const { stickyBiometricHeaders, nonStickyBiometricHeaders } =
    getBiometricHeaders(bioStatKeys, statDefinitions);

  const bioScoutcombined = stickyBiometricHeaders.concat(
    nonStickyBiometricHeaders,
  );
  const bioScoutWithFilters = filterStatHeaders.concat(bioScoutcombined);

  const stickyHeaders = BASE_SCOUT_HEADERS;

  const headers =
    selectedCategoryName === BIO_CATEGORY.name
      ? stickyHeaders.concat(bioScoutWithFilters)
      : stickyHeaders.concat(columnStatHeaders);

  const hasVideoHeaders = headers?.map((header) => {
    const statDef = statDefinitions.find((def) => def.name === header.key);
    return {
      ...header,
      hasVideo: statDef ? statDef.hasVideo : false,
    };
  });
  return {
    headers: hasVideoHeaders,
    filterStatHeaders,
  };
}
